import { dummyScanData } from './dummyData';

export function useGetScanData(data) {
  if (!data) {
    return [];
  }
  return data.map((d, i) => {
    return {
      key: i,
      ...d,
    };
  });
}
